module.exports = __webpack_public_path__ + "static/SouldollB-1a5dfaf69cf50e0e712ce65fee8b1e15.gif";